import {createContext, Dispatch} from 'react';

type initialStateType={
  _id: number,
  Permisos: any,
  FullName: string,
  Usuario: string,
  img: string,
  updateModal: boolean,
  createModal: boolean,
  deleteModal: boolean
};

type ModalPartial = {
    state: initialStateType,
    dispatch: Dispatch<any>
}

export const initialState ={
  _id: 0,
  Permisos:{},
  FullName: '',
  Usuario: '',
  img: '',
  updateModal: false,
  createModal: false,
  deleteModal: false
}

export enum Types{
  UPDATE_ADMINISTRATORS = "UPDATE_ADMINISTRATORS",
  CREATE_ADMINISTRATORS = "CREATE_ADMINISTRATORS",
  DELETE_ADMINISTRATORS = "DELETE_ADMINISTRATORS",
  CLEAR_ADMINISTRATORS = "CLEAR_ADMINISTRATORS",
  UPDATE_ADMINISTRATORS_PERMISOS = "UPDATE_ADMINISTRATORS_PERMISOS",
  CHECK_PERMISSION = "CHECK_PERMISSION"
}
    
const ModalInitialState = {
  state: initialState,
  dispatch: () => null
}

const AdministratorsContext = createContext<ModalPartial>(ModalInitialState);
    
export default AdministratorsContext;